import { defineStore } from 'pinia';
import router from '@/router';

const useNavStore = defineStore('nav', {
    state: () => ({
        basePage: null,
        page: null,
        scrollPositions: {},
        menu: [
            {
                link: '/',
                name: '/',
                title: 'nav.main',
                permission: [],
                // permission: ['admin', 'playlist_curator', 'artist_curator'],
                pages: ['main']
            }
        ]
    }),
    getters: {
        menuItemIsActive: (state) => (name) => state.basePage === name
    },
    actions: {
        setPage(name) {
            this.page = name;
            this.basePage = this.menu.find(item => item.name === name || item.pages.indexOf(name) !== -1)?.name || this.basePage || this.menu[0].name;
        },
        open(name) {
            delete this.scrollPositions[name];

            this.setPage(name);
            router.push({ name });
        },
        back() {
            const data = this.menu.find(item => item.pages.indexOf(this.page) !== -1);

            router.back(data?.name);
        },
        ready(page) {
            if (page !== this.page) {
                return;
            }
        }
    }
});

export default useNavStore;
